import React from 'react'
import styled from 'styled-components'

const StyledButton = styled.button`
  font-size: 100%;
  padding: 0.25rem 1rem;
  border: 1px solid ${({ theme }) => theme.colors.darkGrey};
  background: ${({ active, theme }) => (active ? theme.colors.grey : theme.colors.white)};
  ${({ active, theme }) => active && `color: ${theme.colors.white}`};
  margin: 0 0.5rem 0.5rem 0;
  height: ${({ height }) => height || 'auto'};
  width: ${({ width }) => width || 'auto'};
  margin: ${({ margin }) => margin || '4px'};
  transition: 0.3s;
  :hover {
    background: darkGrey;
  }
`

const FilterButton = ({ children, onClick, width, height, margin, active }) => {
  return (
    <StyledButton
      height={height}
      margin={margin}
      type="button"
      width={width}
      onClick={onClick}
      active={active}
    >
      {children}
    </StyledButton>
  )
}
export default FilterButton
